import React from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import {getText} from 'helpers/language-helper';
import {loginUiTexts} from 'data/ui-texts/login-ui-texts';
import {adminUiTexts} from 'data/ui-texts/admin-ui-texts';
import Button from 'components/ui/button/button';
import './admin-header.scss';


const AdminHeader = ({languageId, email, goToPage, handleLogout}) => {
	return (
		<div className="AdminHeader">
			
			{/* TItle */ }
			<div className="AdminHeader-title"><span>{appConfig.name}</span></div>

			{/* User info */}
			<div className="AdminHeader-userInfo">
				<span>{getText(adminUiTexts.loggedInAs, languageId)}:</span>
				<span>{email}</span>
			</div>

			{/* Logout btn */}
			<div className="AdminHeader-logoutBtn">
				<Button 
					classes={['logout']} 
					text={getText(loginUiTexts.logout, languageId)} 
					onClick={() => {handleLogout();}} 
				/>
			</div>

			{/* Choose language btn */}
			<div 
				className={'AdminHeader-languageBtn ' + languageId} 
				onClick={() => {goToPage('language');}}
			/>
		</div>
	);
};

AdminHeader.propTypes = {
	languageId: PropTypes.string.isRequired,
	email: PropTypes.string.isRequired,
	goToPage: PropTypes.func.isRequired,
	handleLogout: PropTypes.func.isRequired,
};

export default AdminHeader;